export default {
  init() {
    // JavaScript to be fired on the home page
    $('.right-banners .top-item p .banner-link').attr('aria-label', 'Välkommen till Västernorrlands museum!');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js